var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCehck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 27.5938L23.4375 32.375L31.25 21.2188M43.75 26C43.75 28.6951 42.4383 31.0777 40.4305 32.5199C40.8502 34.9874 40.1259 37.6179 38.2578 39.5234C36.3897 41.4288 33.8109 42.1676 31.3917 41.7396C29.9778 43.7873 27.6421 45.125 25 45.125C22.358 45.125 20.0223 43.7873 18.6084 41.7398C16.1889 42.1683 13.6095 41.4296 11.741 39.5238C9.87263 37.618 9.14843 34.9871 9.56846 32.5191C7.56126 31.0769 6.25 28.6947 6.25 26C6.25 23.3052 7.56137 20.9229 9.5687 19.4807C9.1489 17.0129 9.87313 14.3823 11.7414 12.4766C13.6097 10.571 16.1888 9.83228 18.6082 10.2605C20.0221 8.21279 22.3579 6.875 25 6.875C27.642 6.875 29.9777 8.21268 31.3916 10.2603C33.8112 9.83182 36.3905 10.5705 38.259 12.4763C40.1274 14.3821 40.8516 17.013 40.4316 19.4809C42.4387 20.9231 43.75 23.3053 43.75 26Z",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCehck);
export default __webpack_public_path__ + "static/media/cehck.0db4f68f92a48abcc20dd77d7211b090.svg";
export { ForwardRef as ReactComponent };